'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

require('babel-polyfill');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _create = require('./redux/create');

var _create2 = _interopRequireDefault(_create);

var _ApiClient = require('api/ApiClient');

var _ApiClient2 = _interopRequireDefault(_ApiClient);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _reactRouterRedux = require('react-router-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _useStandardScroll = require('scroll-behavior/lib/useStandardScroll');

var _useStandardScroll2 = _interopRequireDefault(_useStandardScroll);

var _routes = require('./routes');

var _routes2 = _interopRequireDefault(_routes);

var _IBonusProxy = require('api/IBonusProxy');

var _IBonusProxy2 = _interopRequireDefault(_IBonusProxy);

var _LocalStorageProxy = require('./ibonus/LocalStorageProxy');

var _LocalStorageProxy2 = _interopRequireDefault(_LocalStorageProxy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var client = new _ApiClient2.default();
var ibonus = new _IBonusProxy2.default(client, _LocalStorageProxy2.default, {});
var _browserHistory = (0, _useStandardScroll2.default)(function () {
    return _reactRouter.browserHistory;
})();
var dest = document.getElementById('content');
var store = (0, _create2.default)(_browserHistory, client, ibonus, window.__data);
var history = (0, _reactRouterRedux.syncHistoryWithStore)(_browserHistory, store);

ibonus.channelId = store.getState().setting.channelId;
ibonus.profileId = store.getState().setting.profileId;
ibonus.onlineShopId = store.getState().setting.shopId;

var component = _react2.default.createElement(
    _reactRouter.Router,
    { render: function render(props) {
            return _react2.default.createElement(_reduxAsyncConnect.ReduxAsyncConnect, (0, _extends3.default)({}, props, { helpers: { client: client }, filter: function filter(item) {
                    return !item.deferred;
                } }));
        }, history: history
    },
    (0, _routes2.default)(store)
);

_reactDom2.default.render(_react2.default.createElement(
    _reactRedux.Provider,
    { store: store, key: 'provider' },
    component
), dest);

if (process.env.NODE_ENV !== 'production') {
    window.React = _react2.default; // enable debugger

    if (!dest || !dest.firstChild || !dest.firstChild.attributes || !dest.firstChild.attributes['data-react-checksum']) {
        console.error('Server-side React render was discarded. Make sure that your initial render does not contain any client-side code.');
    }
}

if (__DEVTOOLS__ && !window.devToolsExtension) {
    var DevTools = require('./containers/DevTools/DevTools');
    _reactDom2.default.render(_react2.default.createElement(
        _reactRedux.Provider,
        { store: store, key: 'provider' },
        _react2.default.createElement(
            'div',
            { className: 'u-full-height' },
            component,
            _react2.default.createElement(DevTools, null)
        )
    ), dest);
}


//////////////////
// WEBPACK FOOTER
// ./src/client.js
// module id = 1594
// module chunks = 0